<script setup lang="ts">
import { computed, ref } from 'vue'
import {
  NXGDSTabGroup,
  NXGDSTab,
  NXGDSTabState,
  type NXGDSTabProps
} from '@nsftx/seven-nxg-design-system'

import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'
import { useRouter } from 'vue-router'

const store = useCmsConfigStore()
const router = useRouter()

const collections = computed(() => {
  return (
    store.cmsConfig?.collections?.docs.map((collection) => {
      return {
        text: collection.title,
        id: collection.id
      }
    }) || []
  )
})

const menuItems = ref<Array<NXGDSTabProps & { route: string }>>([
  {
    text: '',
    state: NXGDSTabState.selectedSubtle,
    route: router.resolve({ name: 'home' }).href,
    prependIcon: 'menu-a',
    size: 'big'
  }
])

const allMenuItems = computed((): Array<NXGDSTabProps & { route: string }> => {
  return [
    ...menuItems.value,
    ...collections.value.map((collection) => ({
      text: collection.text,
      state: NXGDSTabState.default,
      route: router.resolve({ name: 'collection', params: { id: collection.id } }).href
    }))
  ]
})

const activeRoute = computed({
  get: () => router.currentRoute.value.path,
  set: (path: string | number) => {
    router.push(String(path))
  }
})

const handleClick = (selectedItem: NXGDSTabProps & { route: string }) => {
  if (selectedItem.state === NXGDSTabState.disabled) return

  router.push(selectedItem.route)
}
</script>

<template>
  <div>
    <NXGDSTabGroup
      v-model="activeRoute"
      size="big"
      type="line"
      :active-state="NXGDSTabState.selectedSubtle"
    >
      <NXGDSTab
        v-for="item in allMenuItems"
        :key="item.route"
        :value="item.route"
        :text="item.text"
        :prepend-icon="item.prependIcon"
        :variant="item.variant"
        :size="item.size"
        @click="handleClick(item)"
      />
    </NXGDSTabGroup>
  </div>
</template>
